import { render, staticRenderFns } from "./AddRequestDialog.vue?vue&type=template&id=2458e8b8"
import script from "./AddRequestDialog.vue?vue&type=script&lang=js"
export * from "./AddRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports